import { numberFormat } from '../../../numeral';
import styles from '../../../../sass/status.module.scss';
function Enrollments(_ref) {
  var _ref$numberStudentsEn = _ref.numberStudentsEnrolled,
    numberStudentsEnrolled = _ref$numberStudentsEn === void 0 ? 0 : _ref$numberStudentsEn,
    _ref$numberEnrollment = _ref.numberEnrollments,
    numberEnrollments = _ref$numberEnrollment === void 0 ? 0 : _ref$numberEnrollment;
  return /*#__PURE__*/React.createElement("div", {
    className: styles['status-panel-container']
  }, /*#__PURE__*/React.createElement("div", {
    className: "cb-score-metric"
  }, /*#__PURE__*/React.createElement("p", {
    className: "cb-score-label"
  }, "Students"), /*#__PURE__*/React.createElement("span", {
    className: "cb-score-value cb-font-weight-medium"
  }, numberFormat(numberStudentsEnrolled))), /*#__PURE__*/React.createElement("div", {
    className: "cb-score-metric"
  }, /*#__PURE__*/React.createElement("p", {
    className: "cb-score-label"
  }, "Enrollments"), /*#__PURE__*/React.createElement("span", {
    className: "cb-score-value cb-font-weight-medium"
  }, numberFormat(numberEnrollments))));
}
export default Enrollments;